import api from './api';

export const cardService = {
    // Récupérer les profils
    getProfiles: async (userId, ageMin, ageMax, longitude, latitude, distance, gender) => {
        try {
            const response = await api.get(
                `/user/discovers/${userId}/${ageMin}/${ageMax}/${longitude}/${latitude}/${distance}/${gender}`
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching profiles:', error);
            throw error;
        }
    },

    // Créer un swipe
    createSwipe: async (swipeData) => {
        try {
            const response = await api.post('/card/swipe', swipeData);
            return response.data;
        } catch (error) {
            console.error('Error creating swipe:', error);
            throw error;
        }
    },

    // Supprimer un swipe
    deleteSwipe: async (swipeId) => {
        try {
            const response = await api.delete(`/card/swipe/${swipeId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting swipe:', error);
            throw error;
        }
    },

    // Mettre à jour les statistiques de swipe
    updateSwipeStats: async (userId, stats) => {
        try {
            const response = await api.post(
                `/user/${userId}/swipe-stats`,
                stats
            );
            return response.data;
        } catch (error) {
            console.error('Error updating swipe stats:', error);
            throw error;
        }
    },

    // Récupérer les statistiques de swipe
    getSwipeStats: async (userId) => {
        try {
            const response = await api.get(
                `/user/${userId}/swipe-stats`
            );
            return response.data;
        } catch (error) {
            console.error('Error getting swipe stats:', error);
            throw error;
        }
    }
};
